import React from 'react';
import { useListBigQueryRoutineArguments } from 'query/acg/phase-1';
import { Controller, useFormContext } from 'react-hook-form';
import ReactTable from 'react-table';
import { Tag } from 'antd';
import BQArgumentsInputRenderer from '../../BQRoutineManagement/components/BQArgumentsInputRenderer';
import useDeepCompareEffect from 'react-use/lib/useDeepCompareEffect';
import { getArgumentsConfigAsObject } from '../../BQRoutineManagement/utils';

const columnsDefs = [
  {
    id: 'key',
    Header: 'Argument Name',
    accessor: row => <b>{row.argumentName}</b>,
    maxWidth: 200,
  },
  {
    id: 'value',
    Header: 'Argument Value',
    accessor: row => {
      return (
        <Controller
          name={`routineArguments.${row.argumentName}`}
          render={({ field: { onChange, onBlur, value } }) => {
            return (
              <BQArgumentsInputRenderer
                dataType={row.dataType}
                placeholder="Enter argument value"
                selectOptions={row.defaultSelectOptions}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
              />
            );
          }}
        />
      );
    },
  },
];

export default function ArgumentsForm() {
  const form = useFormContext();
  const routineName = form.watch('routineName');
  const { data, isLoading } = useListBigQueryRoutineArguments(routineName);
  useDeepCompareEffect(() => {
    if (data) {
      form.setValue('routineArguments', getArgumentsConfigAsObject(data));
    }
  }, [data]);
  return (
    <div className="space-y-2">
      <b>Arguments</b>
      <ReactTable
        columns={columnsDefs}
        data={data}
        loading={isLoading}
        minRows={0}
        pageSize={data?.length}
        showPagination={false}
      />
    </div>
  );
}
